import {NotFound, OmneticReport, Report, VinInput} from '@mira/report';
import {Footer} from '@mira/ui';

import {createBrowserRouter, Outlet, RouterProvider} from 'react-router-dom';

import './index.css';
import {ReduxProvider} from './providers/ReduxProvider';

function Layout() {
  return (
    <>
      <Outlet />
      <Footer />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {path: '/', element: <VinInput />},
      {path: '/report', element: <OmneticReport />},
      {path: '/report/:vin', element: <Report />},
      {path: '*', element: <NotFound />},
    ],
  },
]);

export function App() {
  return (
    <ReduxProvider>
      <RouterProvider router={router} useTransitions={false} />
    </ReduxProvider>
  );
}
